import { WORK_MODULES, HUB_TRAMITES } from "@/modules/workModuleCore";
import { entitlementIdForWorkModule, isEntitlementActive } from "@/modules/catalogModulos";

export const MODULE_NOT_IN_PLAN_MESSAGE =
  "Módulo no incluido en tu plan. Contáctanos para habilitarlo.";

/**
 * Resuelve si el usuario tiene acceso contratado al módulo (licencia / diseñador / emisor).
 * Soporta payload v2 (entitlements) y flags legacy modulo_*.
 */
/**
 * @returns {boolean|null} true=acceso, false=denegado, null=cargando (sin decidir aún)
 */
export function resolveHubModuleAccess(
  cardId,
  {
    isPlatformDesigner = false,
    permLoading = false,
    modulo_visor_sat = true,
    modulo_asistente_laboral = false,
    modulo_tramites_fiscales = true,
    modulo_gestion_despacho = false,
    entitlements = null,
  } = {},
) {
  if (isPlatformDesigner) return true;
  if (permLoading) return null;

  if (cardId === WORK_MODULES.DISENADOR) return false;

  const ctx = {
    entitlements,
    modulePermissions: {
      modulo_visor_sat,
      modulo_asistente_laboral,
      modulo_tramites_fiscales,
      modulo_gestion_despacho,
    },
  };

  const eid = entitlementIdForWorkModule(cardId);
  if (eid) {
    return isEntitlementActive(eid, ctx);
  }

  if (cardId === WORK_MODULES.VISOR_SAT || cardId === HUB_TRAMITES) {
    return isEntitlementActive("visor", ctx);
  }
  return true;
}
